import Vue from "vue";
import Vuex from "vuex";

import { abilityPlugin } from "./ability";
import employers from "./modules/employers";
import employees from "./modules/employees";
import users from "./modules/users";
import common from "./modules/common";
import reportCategories from "./modules/report_categories";
import queryResults from "./modules/query_results";
import fileProcessing from "./modules/files_processing";
import fileSource from "./modules/file_source";
import pgpCertificate from "./modules/pgp_certificate";
import transactions from "./modules/transactions";
import incentiveProcessing from "./modules/incentive_processing";
import extracts from "./modules/extracts";
import roles from "./modules/roles";
import permissions from "./modules/permissions";
import programs from "./modules/basic_programs";
import levels from "./modules/basic_levels";
import rewards from "./modules/basic_rewards";
import activities from "./modules/basic_level_activities";
import programPoints from "./modules/basic_program_points";
import programActivities from "./modules/basic_activities";
import emailTemplates from "./modules/email_template";
import programRewardError from "./modules/basic_program_rewards_error";
import programRewardHistory from "./modules/basic_program_rewards_history";
import rewardAccessToken from "./modules/basic_rewards_access_token";
import clientRewardsSetting from "./modules/client_rewards_setting";
import history from "./modules/history";
import sisense from "./modules/sisense";
import subgroup from "./modules/subgroup";
import termCondition from "./modules/term_and_condition";
import consent from "./modules/consent";
import clientBrand from "./modules/client_brand";
import levelPaths from "./modules/basic_paths";
import biometricData from "./modules/basic_program_biometric_data";
import healthyRange from "./modules/basic_program_healthy_range";
import cohort from "./modules/basic_program_cohorts";
import columnMapping from "./modules/column_mapping";
import programRequirementItems from "./modules/basic_program_requirement_items";
import clientAdmin from "./modules/user-provisioning";
import collection from "./modules/basic_program_collection";
import milestones from "./modules/basic_program_milestones";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [abilityPlugin],
  modules: {
    employers,
    employees,
    users,
    common,
    reportCategories,
    queryResults,
    fileProcessing,
    fileSource,
    pgpCertificate,
    transactions,
    incentiveProcessing,
    extracts,
    roles,
    permissions,
    programs,
    levels,
    activities,
    rewards,
    programPoints,
    programActivities,
    emailTemplates,
    programRewardError,
    programRewardHistory,
    history,
    sisense,
    rewardAccessToken,
    clientRewardsSetting,
    subgroup,
    termCondition,
    consent,
    clientBrand,
    levelPaths,
    biometricData,
    healthyRange,
    milestones,
    cohort,
    columnMapping,
    programRequirementItems,
    clientAdmin,
    collection
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js